"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const users_1 = require("../fragments/users");
const featureFlagsDetailData_1 = require("../fragments/featureFlagsDetailData");
exports.disableWorkspaceMembership = graphql_tag_1.default `
  mutation disableWorkspaceMembership(
    $id: ID!
  ) {
    disableWorkspaceMembership(
      id: $id
    ) {
      id
      isActive
    }
  }
`;
exports.enableWorkspaceMembership = graphql_tag_1.default `
  mutation enableWorkspaceMembership(
    $id: ID!
  ) {
    enableWorkspaceMembership(
      id: $id
    ) {
      id
      isActive
    }
  }
`;
exports.toggleWorkspaceMembershipAdmin = graphql_tag_1.default `
  mutation toggleWorkspaceMembershipAdmin(
    $id: ID!,
    $isAdmin: Boolean!
  ) {
    toggleWorkspaceMembershipAdmin(
      id: $id,
      isAdmin: $isAdmin
    ) {
      id
      isWorkspaceAdmin
    }
  }
`;
exports.resetPassword = graphql_tag_1.default `
  mutation resetPassword(
    $data: UserResetPasswordInput!
  ) {
    resetPassword(
      data: $data
    ) {
      id
    }
  }
`;
exports.changePassword = graphql_tag_1.default `
  mutation changePassword(
    $data: UserChangePasswordInput!
  ) {
    changePassword(
      data: $data
    ) {
      id
    }
  }
`;
exports.setCurrentWorkspaceMembership = graphql_tag_1.default `
  mutation setCurrentWorkspaceMembership(
    $workspaceMembershipId: ID!
  ) {
    setCurrentWorkspaceMembership(
      workspaceMembershipId: $workspaceMembershipId
    ) {
      id
      currentWorkspaceMembership {
        id
        workspace {
          id
          name
          enabledIntegrationClasses
        }
      }
    }
  }
`;
exports.createUser = graphql_tag_1.default `
  mutation createUser(
    $data: UserInput!
  ) {
    createUser(
      data: $data
    ){
      id
      email
    }
  }
`;
exports.createAndInviteUser = graphql_tag_1.default `
  mutation createAndInviteUser(
    $data: AddAndInviteUserInput!
  ) {
    createAndInviteUser(
      data: $data
    ){
      id
      createdAt
      sent
      usedToSignupAt
      error
      user {
        ...basicUserDetailData
      }
    }
  }
  ${users_1.basicUserDetailData}
`;
exports.updateUser = graphql_tag_1.default `
  mutation updateUser(
    $id: ID!,
    $data: UserUpdateInput!
  ) {
    updateUser(
      id: $id,
      data: $data
    ) {
      id
      email
      fullName
      isAppAdmin
    }
  }
`;
exports.updateUserFeatureFlags = graphql_tag_1.default `
  mutation updateUserFeatureFlags(
    $id: ID!,
    $data: FeatureFlagsInput!
  ) {
    updateUserFeatureFlags(
      id: $id,
      data: $data
    ) {
      featureFlagOverrides {
        ...featureFlagsDetailData
      }
    }
  }
  ${featureFlagsDetailData_1.featureFlagsDetailData}
`;
exports.login = graphql_tag_1.default `
  mutation login(
    $data: UserLoginInput!
  ) {
    login(
      data: $data
    ) {
      id
      email
    }
  }
`;
exports.loginAs = graphql_tag_1.default `
  mutation loginAs(
    $id: ID!
  ) {
    loginAs(
      id: $id
    ) {
      id
      email
    }
  }
`;
exports.loginWithMagicLink = graphql_tag_1.default `
  mutation loginWithMagicLink(
    $token: String!
  ) {
    loginWithMagicLink(
      token: $token
    ) {
      id
      email
    }
  }
`;
exports.signup = graphql_tag_1.default `
  mutation signup(
    $data: UserSignupInput!
  ) {
    signup(
      data: $data
    ) {
      email
    }
  }
`;
exports.signupWithInvite = graphql_tag_1.default `
  mutation signupWithInvite(
    $data: UserSignupWithInviteInput!
  ) {
    signupWithInvite(
      data: $data
    ) {
      email
    }
  }
`;
exports.inviteUser = graphql_tag_1.default `
  mutation inviteUser(
    $id: ID!
  ) {
    inviteUser(
      id: $id
    ) {
      id
      createdAt
      user {
        ...basicUserDetailData
      }
    }
  }
  ${users_1.basicUserDetailData}
`;
exports.logout = graphql_tag_1.default `
  mutation logout {
    logout
  }
`;
exports.sendMagicLink = graphql_tag_1.default `
  mutation sendMagicLink(
    $email: String!
  ) {
    sendMagicLink(
      email: $email
    ) {
      id
    }
  }
`;
exports.forgotPassword = graphql_tag_1.default `
  mutation forgotPassword(
    $data: EmailOnlyInput!
  ) {
    forgotPassword(
      data: $data
    ) {
      id
    }
  }
`;
//# sourceMappingURL=users.js.map